<template>
    <div>
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="set-value-modal-label">Duplikat Template untuk tahun {{ year }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="text-center" v-if="loading">Mohon tunggu</div>
                    <template v-else>
                        <div>
                            <div class="form-group col-md-12 mb-0">
                                <label>Dari Tahun</label>
                                <select name="from_year" class="form-control">
                                    <option :value="val" v-for="(val, key) in duplicates" :key="key">{{ val }}</option>
                                </select>
                            </div>
                        </div>
                    </template>
                </div>
                <div class="modal-footer">
                    <div class="col-md-12 d-flex">
                        <div class="flex-column justify-content-end">
                            <div v-if="saveLoading" class="spinner-border text-primary" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                            <button type="button" class="btn btn-primary" @click="save" :disabled="saveLoading"><i class="la la-save"></i>&nbsp;Proses</button>
                            <button type="button" class="btn btn-secondary" @click="close" data-dismiss="modal">Tutup</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: 'DeleteTemplateForm',
        props: {
            token: String,
            year: {
                type: String,
                default: () => (null)
            },
            duplicates: {
                type: Array,
                default: () => ([])
            }

        },
        data() {
            return {
                items: [],
                loading: false,
                saveLoading: false,
            }
        },
        watch: {
            year(val) {
                this.loading = true
                this.initValue()
                setTimeout(() => {
                    this.loading = false
                }, 1500)
            },
        },
        computed: {
            getTitle() {
                if (!this.data) return ''
                return this.data.indicator ? this.data.indicator.name : ''
            }
        },
        methods: {
            initValue() {
                if (this.data.criteria_value_data) {
                    this.items = this.data.criteria_value_data
                } else {
                    this.addNew()
                }
            },
            addNew() {
                this.items.push({
                    result_name: null,
                    result_parameter: null,
                    result_parameter_label: null
                })
            },
            remove(key) {
                this.items.splice(key, 1)
            },
            setErrorMessage(message = '', key = '') {
                swal.fire(
                    'Formulir belum lengkap',
                    `Mohon lengkapi formulir ${message} pada baris ${key}`,
                    'error'
                )
            },
            save() {
                this.items.map((item, key) => {
                    if (!item.result_name) {
                        this.setErrorMessage(`Nilai`, key+1)
                        return false
                    }
                })
                this.saveLoading = true
                const params = {
                    _token: this.token,
                    items: this.items,
                }
                axios.patch(`/master-data/report-blu/${this.data.id}`, params).then(({data}) => {
                    this.saveLoading = false
                    swal.fire(
                        'Sukses!',
                        data.message,
                        'success'
                    ).then(() => {
                        window.location = ''
                    })
                }).catch((err) => {
                    this.saveLoading = false
                    const { data } = err.response
                    swal.fire(
                        'Opps!',
                        data.message,
                        'error'
                    )
                })
            },
            close() {
                this.items = []
            }
        }
    }
</script>
